import LivenStatementIcon1 from 'assets/livenstatement/1.svg';
import LivenStatementIcon2 from 'assets/livenstatement/2.svg';
import LivenStatementIcon3 from 'assets/livenstatement/3.svg';
import LivenStatementIcon4 from 'assets/livenstatement/4.svg';
import LivenStatementIcon5 from 'assets/livenstatement/5.svg';

export type Option = {
  id: string;
  icon?: string;
};

export const DEFAULT_OPTIONS: Option[] = [{ id: 'yes' }, { id: 'no' }];

export const RELATE_SCALE_OPTIONS: Option[] = [
  { id: 'disagree', icon: LivenStatementIcon1 },
  { id: 'mildy', icon: LivenStatementIcon2 },
  { id: 'moderately', icon: LivenStatementIcon3 },
  { id: 'severely', icon: LivenStatementIcon4 },
  { id: 'agree', icon: LivenStatementIcon5 },
];
